<template>
  <div class="payment">
    <div class="x-flex x-row-between">
      <el-input
        placeholder="商户手机号，姓名，商户号，门店名"
        v-model="payInputVal"
        size="medium"
        style="width: 340px"
        class="x-m-r-12"
      >
        <el-button slot="append" @click="nowPage=1;init()" type="primary">搜索</el-button>
      </el-input>
      <div>
        <el-button
          size="medium"
          type="primary"
          @click="isRegisterQRcodeDialogShow = true"
          >商家自助进件二维码</el-button
        >
        <el-button size="medium" type="danger" @click="fAddPaymentConfig"
          >新增支付进件</el-button
        >
      </div>
    </div>
    <el-card class="x-m-t-8 x-rela">
      <div style="height: calc(100vh - 160px)">
        <vxe-table
          border
          resizable
          highlight-hover-row
          height="94%"
          :data="tableData"
          align="center"
        >
          <vxe-column
            field="RC"
            title="序号"
            width="50"
            fixed="left"
          ></vxe-column>
          <vxe-column field="state" title="状态" width="100px"></vxe-column>
          <vxe-column
            field="partner_phone"
            title="合作伙伴手机号"
            width="140px"
          ></vxe-column>

          <vxe-column
            field="partner_name"
            title="合作伙伴"
            width="140px"
          ></vxe-column>
          <vxe-column
            field="md_name"
            title="商户名称"
            width="200px"
          ></vxe-column>
          <vxe-column
            field="sh_sim_name"
            title="商户简称"
            width="150px"
          ></vxe-column>
          <vxe-column
            field="sh_name"
            title="收款人名"
            width="110px"
          ></vxe-column>
          <vxe-column
            field="sh_phone"
            title="手机号码"
            width="120px"
          ></vxe-column>

          <vxe-column
            field="bus_type"
            title="所属行业"
            width="130px"
          ></vxe-column>
          <vxe-column
            field="sfz_no"
            title="身份证号"
            width="170px"
          ></vxe-column>
          <vxe-column title="经营地址" width="220px">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.md_shen +
                  " " +
                  scope.row.md_shi +
                  " " +
                  scope.row.md_qu
                }}
              </div>
            </template>
          </vxe-column>
          <vxe-column
            field="yhk_no"
            title="银行卡号"
            width="170px"
          ></vxe-column>
          <vxe-column
            field="sh_phone"
            title="银行卡绑定手机号"
            width="140px"
          ></vxe-column>
          <vxe-column
            field="yhk_khh_name"
            title="开户银行"
            width="200px"
          ></vxe-column>
          <vxe-column title="开户地址" width="220px">
            <template slot-scope="scope">
              {{ scope.row.yhk_shen }} {{ scope.row.yhk_shi }}
              {{ scope.row.yhk_qu }}
            </template>
          </vxe-column>
          <vxe-column field="user_memo" title="备注" width="100px"></vxe-column>
          <vxe-column
            field="partner_comp_name"
            title="合作伙伴公司"
            width="200px"
          ></vxe-column>
          <vxe-column
            field="chg_time"
            title="修改时间"
            width="200px"
          ></vxe-column>
          <vxe-column title="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-link
                  type="primary"
                  @click="fEdit(scope.row.sh_phone, scope.row.partner_phone)"
                  >修改</el-link
                >
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP ? TP : "0" }} 页 {{ TR ? TR : "0" }} 条
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="Number(TR)"
          @current-change="fCurrentChange"
          :current-page="nowPage"
          style="position: absolute; bottom: 15px; right: 20px; z-index: 999"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="isRegisterQRcodeDialogShow"
      width="600px"
      top="10vh"
      :close-on-click-modal="false"
      :before-close="fPaymentCancel"
    >
      <el-row class="x-m-t-35">
        <el-col :span="24" class="x-flex">
          <span class="x-w80 x-p-r-15 must">支付方式</span>
          <el-select
            v-model="registerQRcodePayWay"
            placeholder="请选择"
            class="x-flex-1"
            size="medium"
            disabled
          >
            <el-option
              v-for="item in registerQRcodePayWayList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="x-m-t-20 x-flex">
        <el-col :span="16" class="x-flex">
          <span class="x-w80 x-p-r-15 must">支付费率</span>
          <el-input
            class="x-flex-1"
            size="medium"
            v-model="registerQRcodeRate"
            type="number"
            max="6"
            min="2"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <div class="x-flex x-row-right">
            <el-button
              type="primary"
              size="small"
              @click="fCreateRegisterQRcode"
              >生成自助注册二维码</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="x-flex x-row-center x-w100p">
        <div
          style="width: 350px; height: 400px; margin-top: 30px"
          v-show="isShowRegisterQRcode"
        >
          <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
          <div class="x-text-c x-m-t-25 x-m-b-25">
            将二维码发给商家,商家自助提交资料
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 增加/修改进件信息 -->
    <el-dialog
      :visible.sync="isShPaymentConfig"
      width="1000px"
      top="10vh"
      :close-on-click-modal="false"
      :show-close="false"
      :open="fPaymentCancel"
    >
      <div class="x-flex x-col-center x-row-between">
        <div class="title-left-line x-m-l-10 x-font-16 f600 c-24">修改信息</div>
        <div>
          <!-- v-if="addOrEditPaymentConfig == 'EDIT'" -->
          <el-button
            v-if= "false"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            plain
            @click="fDel"
            >删除</el-button
          >
          <el-button type="primary" size="mini" @click="fSave('save')" plain
            >保存信息</el-button
          >
          <el-button type="primary" size="mini" @click="fAtOnceSubmit"
            >一键进件</el-button
          >
          <el-button
            size="mini"
            type="info"
            icon="el-icon-close"
            @click="fPaymentCancel"
            >退出</el-button
          >
        </div>
      </div>
      <!-- 内容 -->
      <div class="x-m-t-15 x-p-t-15 x-bd-top">
        <!-- 证件上传 -->
        <div class="x-flex x-flex-wrap x-col-start x-m-t-15">
          <div class="x-w100 x-p-r-15 x-text-r must">证件上传</div>
          <div class="x-flex-1 x-flex x-flex-wrap">
            <div class="x-m-b-15" @click="imgType = 'SFZ'">
              <c-upload-img
                type="IDCardPositiveImg"
                :value="shInfo.IDCardPositiveImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5 must">身份证正面</div>
            </div>
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="IDCardOtherSideImg"
                :value="shInfo.IDCardOtherSideImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5 must">身份证反面</div>
            </div>
            <div class="x-m-b-15" @click="imgType = 'YHK'">
              <c-upload-img
                type="bankCardPositiveImg"
                :value="shInfo.bankCardPositiveImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">银行卡正面</div>
            </div>
            <!-- <div class="x-m-b-15">
              <c-upload-img
                type="bankCardOtherSideImg"
                :value="shInfo.bankCardOtherSideImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">银行卡反面</div>
            </div> -->
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="mallImg"
                :value="shInfo.mallImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5 must">门头照</div>
            </div>
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="cashierImg"
                :value="shInfo.cashierImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">收银台照</div>
            </div>
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="mallInnerImg1"
                :value="shInfo.mallInnerImg1"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">店铺内景照1</div>
            </div>
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="mallInnerImg2"
                :value="shInfo.mallInnerImg2"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">店铺内景照2</div>
            </div>
            <div class="x-m-b-15" @click="imgType = ''">
              <c-upload-img
                type="mallInnerImg3"
                :value="shInfo.mallInnerImg3"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5">店铺内景照3</div>
            </div>
            <div class="x-m-b-15" @click="imgType = 'YYZZ'">
              <c-upload-img
                type="businessLicencesImg"
                :value="shInfo.businessLicencesImg"
                @UploadImgChange="fUploadImgChange"
                @CancelImg="fCancelImg"
              ></c-upload-img>
              <div class="x-text-c x-m-t-5 must">营业执照(普通必传)</div>
            </div>
          </div>
        </div>
        <!-- 商户名称 商户简称  手机号码 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">商户名称</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.mallName"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">商户简称</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.shName"
              placeholder="支付后显示的商户名称"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">手机号码</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.phone"
              :disabled="addOrEditPaymentConfig == 'EDIT'"
              @blur="shInfo.bankCardBindPhone = shInfo.phone"
            ></el-input>
          </el-col>
        </el-row>
        <!-- 收款人名  身份证号 经营地址 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">收款人名</span>
            <el-input class="x-flex-1" size="medium" v-model="shInfo.payee">
            </el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">身份证号</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.IDCard"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">经营地址</span>
            <div
              class="x-flex-1 x-flex"
              @click="
                isChooseAddr = true;
                chooseAddrType = 'bus';
              "
            >
              <el-input
                v-model="shInfo.businessAddress"
                size="medium"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <!-- 详细地址 营业执照编码  所属行业 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r">详细地址</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.detailAddr"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-c x-p-l-10 must"
              >营业执照编码</span
            >
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.businessLicencesCode"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">所属行业</span>
            <el-select
              placeholder="请选择"
              size="medium"
              v-model="shInfo.industryId"
              class="x-flex-1"
              @change="fIndustryChange"
              ref="industryRef"
            >
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!--  支付费率 开户银行  支行地区 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">支付费率</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.rate"
              type="number"
              max="6"
              min="2"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">开户银行</span>
            <el-select
              v-model="shInfo.bankOfDeposit"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入银行名称查询"
              :remote-method="fBankRemoteMethod"
              :loading="loading"
              @change="
                (e) => {
                  fBankChange(e, 'bank');
                }
              "
              size="medium"
            >
              <el-option
                v-for="item in bankOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">支行地区</span>
            <div
              class="x-flex-1 x-flex"
              @click="
                isChooseAddr = true;
                chooseAddrType = 'subBank';
              "
            >
              <el-input
                v-model="shInfo.openingAddress"
                size="medium"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <!-- 开户支行 银行卡号  银行卡绑定手机号 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">开户支行</span>
            <el-select
              v-model="shInfo.subBankOfDeposit"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入支行名称查询"
              :remote-method="fSubBankRemoteMethod"
              :loading="loading"
              @change="
                (e) => {
                  fBankChange(e, 'sub-bank');
                }
              "
              size="medium"
            >
              <el-option
                v-for="item in subBankOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">银行卡号</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.bankCard"
            ></el-input>
          </el-col>
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-c x-p-l-10 must"
              >银行卡绑定手机号</span
            >
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.bankCardBindPhone"
            ></el-input>
          </el-col>
        </el-row>
        <!-- 银联号 备注 -->
        <el-row class="x-m-t-15">
          <el-col :span="8" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r must">邮箱</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.email"
            ></el-input>
          </el-col>
          <el-col :span="16" class="x-flex">
            <span class="x-w100 x-p-r-15 x-text-r">开户备注</span>
            <el-input
              class="x-flex-1"
              size="medium"
              v-model="shInfo.remarks"
            ></el-input>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 地址选择 -->
    <el-dialog
      :visible.sync="isChooseAddr"
      width="500px"
      top="10vh"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <!-- <div class="x-font-16 f600 x-p-t-10 x-p-b-10">选择地址</div> -->
      <div class="x-p-t-10 x-p-b-10">选择省</div>
      <el-select
        v-if="chooseAddrType == 'subBank'"
        ref="openShengRef"
        v-model="shInfo.openSheng"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusShengChange(e, 'open')"
      >
        <el-option
          v-for="item in openShengOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-if="chooseAddrType == 'bus'"
        ref="busShengRef"
        v-model="shInfo.busSheng"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusShengChange(e, 'bus')"
      >
        <el-option
          v-for="item in busShengOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="x-p-t-10 x-p-b-10">选择市</div>

      <el-select
        v-if="chooseAddrType == 'subBank'"
        ref="openShiRef"
        v-model="shInfo.openShi"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusShiChange(e, 'open')"
      >
        <el-option
          v-for="item in openShiOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-if="chooseAddrType == 'bus'"
        ref="busShiRef"
        v-model="shInfo.busShi"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusShiChange(e, 'bus')"
      >
        <el-option
          v-for="item in busShiOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="x-p-t-10 x-p-b-10" v-if="chooseAddrType == 'bus'">选择区</div>
      <!-- <el-select
        v-if="chooseAddrType == 'subBank'"
        ref="openQuRef"
        v-model="shInfo.openQu"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusQuChange(e, 'open')"
      >
        <el-option
          v-for="item in openQuOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
      <el-select
        v-if="chooseAddrType == 'bus'"
        ref="busQuRef"
        v-model="shInfo.busQu"
        size="medium"
        class="x-w100p"
        @change="(e) => fBusQuChange(e, 'bus')"
      >
        <el-option
          v-for="item in busQuOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="x-m-t-25 x-flex x-row-right">
        <el-button size="small" type="info" @click="fChooseAddrCencal"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="fChooseAddrConfirm"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 进件方式 -->
    <el-dialog
      :visible.sync="isShPaymentConfigType"
      width="400px"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="x-p-20 x-text-c x-font-17">请选择进件方式</div>
      <div class="x-text-c x-p-30">
        <el-button
          type="primary"
          size="medium"
          @click="fXwAndPtPayment('small_mch_add', 'xw')"
          >小微进件</el-button
        >
        <el-button
          type="warning"
          size="medium"
          @click="fXwAndPtPayment('normal_mch_add', 'pt')"
          >普通进件</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import cUploadImg from "../components/uploadImg.vue";
import QRCode from "qrcodejs2";
export default {
  components: {
    cUploadImg,
  },
  data() {
    return {
      imgType: "",
      isRegisterQRcodeDialogShow: false, // 注册二维码 弹窗
      registerQRcodeRate: "3.8", // 自助注册弹窗 费率
      registerQRcodePayWay: "ZGYL", // 自助注册弹窗 支付方式
      registerQRcodePayWayList: [
        // 自助注册弹窗 支付方式列表
        {
          label: "中国银联",
          value: "ZGYL",
        },
        {
          label: "微邮付",
          value: "WYF",
        },
        {
          label: "付呗",
          value: "FB",
        },
        {
          label: "随行付",
          value: "SXF",
        },
        {
          label: "合利宝",
          value: "HLB",
        },
        {
          label: "好哒支付",
          value: "HDZF",
        },
        {
          label: "星驿付",
          value: "XYF",
        },
        {
          label: "东之付",
          value: "DZF",
        },
        {
          label: "德宏农行付",
          value: "DHNHF",
        },

        {
          label: "陕西信合",
          value: "SXXH",
        },
      ],
      isShowRegisterQRcode: false,
      userPhone: "", // 全局商户手机号
      loading: false,
      openLoading: "",
      payInputVal: "", // 搜索框 数据
      isChooseAddr: false, // 地址选择
      chooseAddrType: "bus", // bus 经营地址  subBank 支行地址
      isShPaymentConfig: false,
      isShPaymentConfigType: false,
      shPaymentConfigType: "", // 进件类型  小微-xw  普通-pt
      addOrEditPaymentConfig: "ADD", // 修改或增加支付进件
      editChoosePhone: "", // 点击修改时 选中的手机号  用户操作(修改) - 用户的信息
      tableData: [],
      // 进件参数
      shInfo: {
        shCode: "", // 进件成功后的商户号
        mallName: "", // 商户名称
        shName: "", // 商户简称
        industry: "", // 所属行业
        industryId: "", // 所属行业 ID
        remarks: "", // 备注
        payee: "", // 收款人
        phone: "", // 手机号码
        email: "", // 邮箱
        partner_phone: "", // 合作伙伴手机号码
        IDCard: "", // 身份证号
        busSheng: "",
        busShengId: "", // 对应编码
        busShi: "",
        busShiId: "", // 对应编码
        busQu: "",
        busQuId: "", // 对应编码
        businessAddress: "", // 经营地址
        detailAddr: "", // 详细地址
        bankCard: "", // 银行卡号
        bankCardBindPhone: "", // 银行卡绑定手机号
        UnionPayCode: "", // 银联号
        bankOfDeposit: "", // 开户银行
        bankOfDepositId: "", // 开户银行 对应 ID
        subBankOfDeposit: "", // 开户支行
        openingAddress: "", // 开户地址
        openSheng: "",
        openShengId: "", // 对应编码
        openShi: "",
        openShiId: "", // 对应编码
        openQu: "",
        openQuId: "", // 对应编码
        businessLicencesCode: "", // 营业执照编号
        rate: "3.8", // 费率
        IDCardPositiveImg: "", // 正面身份证照片
        IDCardPositiveImgFile: "",
        IDCardPositiveImgId: "",
        IDCardOtherSideImg: "", // 反面身份证照片
        IDCardOtherSideImgFile: "",
        IDCardOtherSideImgId: "",
        bankCardPositiveImg: "", // 正面银行卡照片
        bankCardPositiveImgFile: "",
        bankCardPositiveImgId: "",
        bankCardOtherSideImg: "", // 反面银行卡照片
        bankCardOtherSideImgFile: "",
        bankCardOtherSideImgId: "",
        mallImg: "", // 门头照片
        mallImgFile: "",
        mallImgId: "",
        cashierImg: "", // 收银台照片
        cashierImgFile: "",
        cashierImgId: "",
        mallInnerImg1: "", // 门店内景照1
        mallInnerImg1File: "",
        mallInnerImg1Id: "",
        mallInnerImg2: "", // 门店内景照2
        mallInnerImg2File: "",
        mallInnerImg2Id: "",
        mallInnerImg3: "", // 门店内景照3
        mallInnerImg3File: "",
        mallInnerImg3Id: "",
        businessLicencesImg: "", // 营业执照
        businessLicencesImgFile: "",
        businessLicencesImgId: "",
      },
      // 经营地址省市区 列表
      busShengOptions: [],
      busShiOptions: [],
      busQuOptions: [],
      // 开户银行列表
      bankOfDepositOptions: [],
      // 开户银行省市区 列表
      openShengOptions: [],
      openShiOptions: [],
      openQuOptions: [],
      bankOptions: [],
      subBankOptions: [],
      oldSubBankOptions: [],
      industryList: [
        {
          label: "杂货便利店",
          value: "5331",
        },
        {
          label: "百货商店",
          value: "5311",
        },
        {
          label: "快餐店",
          value: "5814",
        },
        {
          label: "餐馆",
          value: "5812",
        },
      ],
      // 小微进件参数
      xwPostJson: {
        // 商户信息
        mallName: "", // 商户名称
        merchantId: "", // 平台商户号 - 修改必传
        merchantName: /*"吴锐"*/ "", // 商户名称  --  长度最长支持64字节  注：UTF-8编码下一个汉字占3个字节
        outMerchantId: "", // 外商户号  --  机构方自己内部系统的商户编号（若没有可自定义），确保唯一
        remark: "", // Y  --  可不传 备注
        chPayAuth: "1", // Y  --  可不传 商户是否授权机构交易，不传默认否  值为0：否；值为1：是(所属机构作为授权交易机构）；值为2：是（以partner合作伙伴ID作为授权交易机构）
        salesmanSerial: "", // Y  --  可不传 业务员序列
        creditPayPreLimit: "", // Y  --  可不传 信用卡单笔限额 单位：分
        creditPayDayLimit: "", // Y  --  可不传 信用卡单日限额 单位：分
        limitCreditPay: "2", // 是否可用信用卡支付  --  0：是 1：否，2：不限制，默认是2
        // 商户详情信息
        merchantDetail: {
          subjectType: "1", // 主体类型	 -  Int  -- 修改必传
          merchantShortName: "", // 商户简称  --  15个汉字内。简称在微信、支付宝、QQ钱包是通用的，不要使用带有具体支付类型的简称，不能为纯数字、不能包含制表符、换行符等
          industrId: "5331", // 行业类型  --  传 int 型数据
          province: "", // 省份  --  值请参看【数据表单】中地区编码附件
          city: "", // 城市  --  值请参看【数据表单】中地区编码附件
          county: "", // 区/县  --  值请参看【数据表单】中地区编码附件
          address: "", // 地址  --
          email: "", // Y  --  可不传 邮箱
          customerPhone: "", // 客服电话  --  必须是数字，且长度7到15位
          principal: "", // 负责人  --
          principalMobile: "", // 负责人手机号  --  必须是正确手机号格式
          idCode: "" /* 342401198607102295 */, // 证件号码  --
          indentityPhoto: "", // 身份证图片  --
          protocolPhoto: "", // 商户协议照  --  调用图片上传接口获取，多张以 ; 分割
          mainPhoto: "", // 门头照  --  调用图片上传接口获取，多张以 ; 分割
          otherDoc: "", // Y  --  可不传 其他资料照片 调用图片上传接口获取，多张以 ; 分割
        },
        // 银行账户信息
        bankAccount: {
          accountCode: "" /* 6228480321493921613 */, // 银行卡号  --  必须是数字
          bankId: "", // 开户银行  --  值请参考银行编号附件
          accountName: "", // 开户人  --
          accountType: "1", // 帐户类型  --  1：个人
          contactLine: "" /* 103331001075 */, // 联行号  --  必须是数字
          bankName: "" /* 中国农业银行杭州汽车城支行 */, // 开户支行名称  --
          province: "", // 开户支行所在省  --  值请参看【数据表单】中地区编码附件
          city: "", // 开户支行所在市  --  值请参看【数据表单】中地区编码附件
          idCardType: "1", // 持卡人证件类型  --  1：身份证 2：护照，账户类型为“1:企业”时非必填
          idCard: "", // 持卡人证件号码  --  账户类型为“1:企业”时非必填； 必须是18正确格式的身份证
          tel: "", // 银行账户手机号  --  开户行预留的手机号，必须是正确手机格式
          address: "", // Y  --  可不传 持卡人地址
        },
        // 商户支付类型信息
        mchPayConfs: [
          // 微信公众号支付-新生支付4910标准通道 银联微信-JS支付 2.1 10000959
          {
            payTypeId: "10000959",
            billRate: "2.1",
          },
          // 微信付款码支付-新生支付4910标准通道 银联微信-小额支付 2.1 10000960
          {
            payTypeId: "10000960",
            billRate: "2.1",
          },
          // 微信扫码支付-新生支付4910标准通道 银联微信-扫码支付 2.1 10000961
          {
            payTypeId: "10000961",
            billRate: "2.1",
          },
          // // 银联付款码支付-新生支付4910商户扫码交易通道 银联二维码-小额支付 多费率 10000973
          // {
          //   payTypeId: "10000973",
          //   billRate: "6",
          //   billRate1: "6",
          //   billRate2: "6",
          //   billRate3: "6",
          // },
          // // 银联扫码支付-新生支付4910商户扫码交易通道 银联二维码-扫码支付 多费率 10000974
          // {
          //   payTypeId: "10000974",
          //   billRate: "6",
          //   billRate1: "6",
          //   billRate2: "6",
          //   billRate3: "6",
          // },
          // 支付宝服务窗支付-新生支付4910（新）标准通道 银联支付宝-JS支付 2.1 10014751
          {
            payTypeId: "10014751",
            billRate: "2.1",
          },
          // 支付宝付款码支付-新生支付4910（新）标准通道 银联支付宝-付款码支付 2.1 10014761
          {
            payTypeId: "10014761",
            billRate: "2.1",
          },
          // 支付宝扫码支付-新生支付4910（新）标准通道 银联支付宝-扫码支付 2.1 10014771
          {
            payTypeId: "10014771",
            billRate: "2.1",
          },
        ],
        sendSms: "", // Y  --  可不传 是否发送短信  1：发送  0：不发送
        sendMail: "", // Y  --  可不传 是否发送邮件 1：发送  0：不发送
      },
      // 普通进件参数
      ptPostJson: {
        merchantName: "", // 商户名称
        outMerchantId: "", // 外商户号
        feeType: "CNY", // 币种  CNY:人民币
        remark: "", //
        chPayAuth: "1", //
        channelId: "", //
        salesmanSerial: "", //
        merchantDetail: {
          subjectType: "2", // 主体类型	 -  Int  -- 修改必传
          merchantShortName: "", // 商户简称  --  15个汉字内。简称在微信、支付宝、QQ钱包是通用的，不要使用带有具体支付类型的简称，不能为纯数字、不能包含制表符、换行符等
          industrId: "5331", // 行业类型  --  传 int 型数据
          province: "", // 省份  --  值请参看【数据表单】中地区编码附件
          city: "", // 城市  --  值请参看【数据表单】中地区编码附件
          county: "", // 区/县  --  值请参看【数据表单】中地区编码附件
          address: "", // 地址  --
          tel: "", // 可不传 电话
          email: "", // Y  --  可不传 邮箱
          legalPerson: "吴锐", // 企业法人
          customerPhone: "", // 客服电话  --  必须是数字，且长度7到15位
          principal: "", // 负责人  --
          principalMobile: "", // 负责人手机号  --  必须是正确手机号格式
          idCode: "", // 证件号码  --
          idCodeType: "1", // 证件类型  1：大陆身份证 2：护照 3：港澳居民来往内地通行证 4：台湾居民来往内地通行证 5：其它
          indentityPhoto: "", // 身份证图片  --
          licensePhoto: "", // 营业执照  --  可不传
          protocolPhoto: "", // 商户协议照  --  调用图片上传接口获取，多张以 ; 分割
          orgPhoto: "", // 组织机构代码照	 -- 可不传
          mainPhoto: "", // 门头照  --  调用图片上传接口获取，多张以 ; 分割
          businessLicense: "", // 营业执照编号  --  可不传
          accountCodePhoto: "", // 银行卡/开户许可证照片	 -- 可不传
          otherDoc: "", // Y  --  可不传 其他资料照片 调用图片上传接口获取，多张以 ; 分割
        },
        bankAccount: {
          accountCode: "", // 银行卡号  --  必须是数字
          bankId: "4", // 开户银行  --  值请参考银行编号附件
          accountName: "", // 开户人  --
          accountType: "2", // 帐户类型  --  1:企业 ;2:个人
          contactLine: "", // 联行号  --  必须是数字
          bankName: "", // 开户支行名称  --
          province: "", // 开户支行所在省  --  值请参看【数据表单】中地区编码附件
          city: "", // 开户支行所在市  --  值请参看【数据表单】中地区编码附件
          idCardType: "1", // 持卡人证件类型  --  1：身份证 2：护照，账户类型为“1:企业”时非必填
          idCard: "", // 持卡人证件号码  --  账户类型为“1:企业”时非必填； 必须是18正确格式的身份证
          address: "", // Y  --  可不传 持卡人地址
          tel: "", // 银行账户手机号  --  开户行预留的手机号，必须是正确手机格式
        },
        mchPayConfs: [
          // 微信公众号支付-新生支付4910标准通道 银联微信-JS支付 2.1 10000959
          {
            payTypeId: "10000959",
            billRate: "2.1",
          },
          // 微信付款码支付-新生支付4910标准通道 银联微信-小额支付 2.1 10000960
          {
            payTypeId: "10000960",
            billRate: "2.1",
          },
          // 微信扫码支付-新生支付4910标准通道 银联微信-扫码支付 2.1 10000961
          {
            payTypeId: "10000961",
            billRate: "2.1",
          },
          // // 银联付款码支付-新生支付4910商户扫码交易通道 银联二维码-小额支付 多费率 10000973
          // {
          //   payTypeId: "10000973",
          //   billRate: "6",
          //   billRate1: "6",
          //   billRate2: "6",
          //   billRate3: "6",
          // },
          // // 银联扫码支付-新生支付4910商户扫码交易通道 银联二维码-扫码支付 多费率 10000974
          // {
          //   payTypeId: "10000974",
          //   billRate: "6",
          //   billRate1: "6",
          //   billRate2: "6",
          //   billRate3: "6",
          // },
          // 支付宝服务窗支付-新生支付4910（新）标准通道 银联支付宝-JS支付 2.1 10014751
          {
            payTypeId: "10014751",
            billRate: "2.1",
          },
          // 支付宝付款码支付-新生支付4910（新）标准通道 银联支付宝-付款码支付 2.1 10014761
          {
            payTypeId: "10014761",
            billRate: "2.1",
          },
          // 支付宝扫码支付-新生支付4910（新）标准通道 银联支付宝-扫码支付 2.1 10014771
          {
            payTypeId: "10014771",
            billRate: "2.1",
          },
        ],
        merchantQrUrl: "", // 商户收款URL
        notifyUrl: "", // 银标码通知url
        queryUrl: "", // 银标码查询url
        sendSms: "", // 是否发送短信
        sendMail: "", // 是否发送邮件
      },
      // 图片补录 参数
      imgSupplementList: {
        merchantId: "",
        merchantDetail: {
          indentityPhoto: "", // 	身份证图片		调用图片上传接口获取，上传正反面两张，以;分割
          protocolPhoto: "", // 	商户协议照		调用图片上传接口获取,最多上传四张。多张以;分割
          orgPhoto: "", // 	组织机构代码照		调用图片上传接口获取,最多上传一张
          mainPhoto: "", // 	门头照		调用图片上传接口获取,最多上传一张
          licensePhoto: "", // 	营业执照图		调用图片上传接口获取,最多上传一张
          businessPlace: "", // 	营业场所照片		调用图片上传接口获取,最多上传一张
          accountCodePhoto: "", // 	银行卡/开户许可证照片		调用图片上传接口获取,最多上传一张
          otherDoc: "", // 	其他资料照片		调用图片上传接口获取，最多四张，多张以;分割
        },
      },
      data: "<merchant>",
      formData: {
        picFile: "",
        dataSign: "",
        serviceName: "pic_upload",
      },
      TP: "", // 页
      TR: "", // 条
      nowPage: "1", // 第几页
    };
  },
  async created() {
    this.userPhone = JSON.parse(
      localStorage.getItem("bykPlatform")
    ).partnerInfo.data.user_phone;
    this.shInfo.partner_phone = JSON.parse(
      localStorage.getItem("bykPlatform")
    ).partnerInfo.data.user_phone;
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let res = await this.fBykPayShInfoManger("GET", "", "", this.userPhone);

      if (res.result != "sucess") {
        return this.$message(res.msg);
      }
      this.TR = 0
      this.TP = 0
      if (res.data && res.data.length > 0) {
        this.tableData = res.data;
        this.TP = res.data[0].TP;
        this.TR = res.data[0].TR;
      } else {
        this.tableData = [];
      }
    },

    // 创建自助注册二维码
    fCreateRegisterQRcode() {
      if (this.bykApi.smCom.fSmIsEmpty(this.registerQRcodeRate)) {
        this.isShowRegisterQRcode = false;
        return this.$message("请输入支付费率");
      }
      if (this.registerQRcodeRate > 6 || this.registerQRcodeRate < 2) {
        this.isShowRegisterQRcode = false;
        return this.$message("支付费率应在 2.0~6.0 之间");
      }
      this.isShowRegisterQRcode = true;
      document.getElementById("qrcodeMax").innerHTML = "";
      let text = `http://wx.91byk.com/bykSellMin/index.html#/pages/reqPay/reqPay?p=${
        this.userPhone
      }&rate=${this.registerQRcodeRate ? this.registerQRcodeRate : "3.8"}`;
      if (!this.bykApi.smCom.fSmIsEmpty(this.registerQRcodePayWay)) {
        text = text + "&pay=" + this.registerQRcodePayWay;
      }
      // this.creatQrCode();
      new this.QRCode(this.$refs.qrCodeUrlMax, {
        text, // 需要转换为二维码的内容
        width: 350,
        height: 350,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    // 开户行
    fBankOfDepositChange(e) {

    },

    // 省市区 change 事件
    async fBusShengChange(e, type) {

      if (type == "bus") {
        this.shInfo.busShengId = e;
        this.shInfo.busShiId = "";
        this.shInfo.busShi = "";
        this.shInfo.busQuId = "";
        this.shInfo.busQu = "";
        this.$nextTick(() => {
          this.shInfo.busSheng = this.$refs.busShengRef.selected.currentLabel;
        });
        this.busShiOptions = await this.getShengShiQu(e);
      } else if (type == "open") {
        this.shInfo.openShengId = e;
        this.shInfo.openShiId = "";
        this.shInfo.openShi = "";
        this.shInfo.openQuId = "";
        this.shInfo.openQu = "";
        this.$nextTick(() => {
          this.shInfo.openSheng = this.$refs.openShengRef.selected.currentLabel;
        });
        this.openShiOptions = await this.getShengShiQu(e);
      }
    },
    // 省市区 change 事件
    async fBusShiChange(e, type) {

      if (type == "bus") {
        this.shInfo.busShiId = e;
        this.shInfo.busQuId = "";
        this.shInfo.busQu = "";
        this.$nextTick(() => {
          this.shInfo.busShi = this.$refs.busShiRef.selected.currentLabel;
        });
        this.busQuOptions = await this.getShengShiQu(e);
      } else if (type == "open") {
        this.shInfo.openShiId = e;
        this.shInfo.openQuId = "";
        this.shInfo.openQu = "";
        this.$nextTick(() => {
          this.shInfo.openShi = this.$refs.openShiRef.selected.currentLabel;
        });
        this.openQuOptions = await this.getShengShiQu(e);
      }
    },
    // 省市区 change 事件
    fBusQuChange(e, type) {

      if (type == "bus") {
        this.shInfo.busQuId = e;
        this.$nextTick(() => {
          this.shInfo.busQu = this.$refs.busQuRef.selected.currentLabel;
          let sheng = this.$refs.busShengRef.selected.currentLabel;
          let shi = this.$refs.busShiRef.selected.currentLabel;
          let qu = this.$refs.busQuRef.selected.currentLabel;
          this.shInfo.businessAddress = sheng + " " + shi + " " + qu;
        });
      } else if (type == "open") {
        this.shInfo.openQuId = e;
        this.$nextTick(() => {
          this.shInfo.openQu = this.$refs.openQuRef.selected.currentLabel;
          // let sheng = this.$refs.openShengRef.selected.currentLabel;
        });
      }
      // let sheng = this.busShengOptions.find((item) => {
      //   return item.value == this.shInfo.busSheng;
      // });
      // let shi = this.busShiOptions.find((item) => {
      //   return item.value == this.shInfo.busShi;
      // });
      // let qu = this.busQuOptions.find((item) => {
      //   return item.value == this.shInfo.busQu;
      // });
      // this.shInfo.businessAddress =
      //   sheng.label + " " + shi.label + " " + qu.label;
    },

    // 省市区 的 数据重组
    async getShengShiQu(code = "") {
      // 获取 省份 列表数据
      let res = await this.fBykGetZgylAreaInfo(code);
      if (res.result != "sucess") {
        return this.$message(res.msg);
      }
      // 省份 数据重组
      let arr = [];
      res.data.map((item) => {
        let obj = {};
        obj.label = item.name.trim();
        obj.value = item.code.trim();
        arr.push(obj);
      });
      return arr;
    },

    async fEdit(phone, partnerPhone) {

      this.addOrEditPaymentConfig = "EDIT";
      this.editChoosePhone = phone;
      this.isShPaymentConfig = true;
      let res = await this.fBykPayShInfoManger(
        "GET_SH_PHONE",
        phone,
        "",
        partnerPhone
      );

      if (res.result != "sucess") {
        return this.$message(res.msg);
      }
      this.shInfo.shCode = res.data[0].sh_no;
      this.shInfo.industry = res.data[0].bus_type;
      this.shInfo.industryId = res.data[0].bus_type_no;
      this.shInfo.remarks = res.data[0].user_memo;
      this.shInfo.payee = res.data[0].sh_name;
      this.shInfo.mallName = res.data[0].md_name;
      this.shInfo.shName = res.data[0].sh_sim_name;
      this.shInfo.phone = res.data[0].sh_phone;
      this.shInfo.email = res.data[0].sh_email;
      this.shInfo.partner_phone = res.data[0].partner_phone;
      this.shInfo.IDCard = res.data[0].sfz_no;
      this.shInfo.busSheng = res.data[0].md_shen;
      this.shInfo.busShengId = res.data[0].md_shen_id;
      this.shInfo.busShi = res.data[0].md_shi;
      this.shInfo.busShiId = res.data[0].md_shi_id;
      this.shInfo.busQu = res.data[0].md_qu;
      this.shInfo.busQuId = res.data[0].md_qu_id;
      this.shInfo.businessAddress =
        res.data[0].md_shen +
        " " +
        res.data[0].md_shi +
        " " +
        res.data[0].md_qu;
      this.shInfo.detailAddr = res.data[0].md_adr;
      this.shInfo.bankCard = res.data[0].yhk_no;
      this.shInfo.rate = res.data[0].sk_fl_value;
      this.shInfo.bankCardBindPhone = res.data[0].yhk_phone;
      this.shInfo.UnionPayCode = res.data[0].yhk_khh_zh_no;
      this.shInfo.bankOfDeposit = res.data[0].yhk_khh_name;
      this.shInfo.bankOfDepositId = res.data[0].yhk_khh_id;
      this.shInfo.subBankOfDeposit = res.data[0].yhk_khh_zh_name;
      this.shInfo.openingAddress =
        res.data[0].yhk_shen + " " + res.data[0].yhk_shi;
      this.shInfo.openSheng = res.data[0].yhk_shen;
      this.shInfo.openShengId = res.data[0].yhk_shen_id;
      this.shInfo.openShi = res.data[0].yhk_shi;
      this.shInfo.openShiId = res.data[0].yhk_shi_id;
      this.shInfo.openQu = res.data[0].yhk_qu;
      this.shInfo.openQuId = res.data[0].yhk_qu_id;
      this.shInfo.businessLicencesCode = res.data[0].yyzz_no;
      this.shInfo.IDCardPositiveImg = res.data[0].pic_sfz_zm_url;
      this.shInfo.IDCardOtherSideImg = res.data[0].pic_sfz_fm_url;
      this.shInfo.bankCardPositiveImg = res.data[0].pic_yhk_zm_url;
      this.shInfo.bankCardOtherSideImg = res.data[0].pic_yhk_fm_url;
      this.shInfo.mallImg = res.data[0].pic_mtz_url;
      this.shInfo.cashierImg = res.data[0].pic_syt_url;
      this.shInfo.mallInnerImg1 = res.data[0].pic_njz1_url;
      this.shInfo.mallInnerImg2 = res.data[0].pic_njz2_url;
      this.shInfo.mallInnerImg3 = res.data[0].pic_njz3_url;
      this.shInfo.businessLicencesImg = res.data[0].pic_yyzz_url;
      this.busShengOptions = await this.getShengShiQu();
      this.busShiOptions = await this.getShengShiQu(this.shInfo.busShengId);
      this.busQuOptions = await this.getShengShiQu(this.shInfo.busShiId);
      this.openShengOptions = await this.getShengShiQu();
      this.openShiOptions = await this.getShengShiQu(this.shInfo.openShengId);
      this.openQuOptions = await this.getShengShiQu(this.shInfo.openShiId);

    },

    // 所属行业 change 事件
    fIndustryChange(e) {
      //
      this.shInfo.industryId = e;
      this.$nextTick(() => {

        this.shInfo.industry = this.$refs.industryRef.selected.currentLabel;
      });
      //
    },

    // 上传图片 change 事件
    async fUploadImgChange(obj) {

      this.shInfo[obj.type] = obj.e.url;
      this.shInfo[obj.type + "File"] = await this.bykApi.smCom.fSmCompressImg(
        obj.e.raw
      );
      // 图片转 base64
      let that = this;
      let imgFile = new FileReader();
      imgFile.readAsDataURL(this.shInfo[obj.type + "File"]);
      imgFile.onload = () => {
        let imgBase64 = imgFile.result; //base64数据
        imgBase64 = encodeURIComponent(imgBase64);
        this.fGetBaiDuOcrResult(imgBase64);
        //
        // if (res.result != "sucess") {
        //   this.$message(res.error_msg);
        // }
      };
    },

    // 增加支付进件
    async fAddPaymentConfig() {
      this.busShengOptions = await this.getShengShiQu();
      this.openShengOptions = await this.getShengShiQu();
      this.addOrEditPaymentConfig = "ADD";
      this.isShPaymentConfig = true;
    },

    // 支付进件的参数组装
    spliceParam(postJson) {
      let keys = Object.keys(postJson);
      let data = "";
      // 判断当前属性的类型
      keys.forEach((key) => {
        if (typeof postJson[key] == "object") {
          // 如果是数组
          if (Array.isArray(postJson[key]) && postJson[key].length > 0) {
            data += "<mchPayConfs>";
            postJson[key].forEach((item) => {
              data += "<mchPayConf>" + this.spliceParam(item) + "</mchPayConf>";
            });
            data += "</mchPayConfs>";
          }
          // 判断是对象
          if (
            Object.prototype.toString.call(postJson[key]) == "[object Object]"
          ) {
            data +=
              "<" +
              key +
              ">" +
              this.spliceParam(postJson[key]) +
              "</" +
              key +
              ">";
          }
        } else {
          if (!this.bykApi.smCom.fSmIsEmpty(postJson[key])) {
            data += "<" + key + ">" + postJson[key] + "</" + key + ">";
          }
        }
      });
      return data;
    },

    // ------------------ 进件 ↓↓↓↓↓↓↓↓ -----------------------
    // 数据初始化
    fPaymentCancel() {
      this.isShPaymentConfig = false;
      this.shInfo = Object.assign({
        mallName: "", // 商户名称
        shName: "", // 商户简称
        industry: "", // 所属行业
        industryId: "", // 所属行业 ID
        remarks: "", // 备注
        payee: "", // 收款人
        phone: "", // 手机号码
        partner_phone: "", // 合作伙伴手机号码
        IDCard: "", // 身份证号
        busSheng: "",
        busShengId: "", // 对应编码
        busShi: "",
        busShiId: "", // 对应编码
        busQu: "",
        busQuId: "", // 对应编码
        businessAddress: "", // 经营地址
        bankCard: "", // 银行卡
        bankCardBindPhone: "", // 银行卡绑定手机号
        UnionPayCode: "", // 银联号
        bankOfDeposit: "", // 开户银行
        bankOfDepositId: "", // 开户银行 对应 ID
        subBankOfDeposit: "", // 开户支行
        openingAddress: "", // 开户地址
        openSheng: "",
        openShengId: "", // 对应编码
        openShi: "",
        openShiId: "", // 对应编码
        openQu: "",
        openQuId: "", // 对应编码
        businessLicencesCode: "", // 营业执照编号
        rate: "3.8", // 费率
        IDCardPositiveImg: "", // 正面身份证照片
        IDCardPositiveImgFile: "",
        IDCardPositiveImgId: "",
        IDCardOtherSideImg: "", // 反面身份证照片
        IDCardOtherSideImgFile: "",
        IDCardOtherSideImgId: "",
        bankCardPositiveImg: "", // 正面银行卡照片
        bankCardPositiveImgFile: "",
        bankCardPositiveImgId: "",
        bankCardOtherSideImg: "", // 反面银行卡照片
        bankCardOtherSideImgFile: "",
        bankCardOtherSideImgId: "",
        mallImg: "", // 门头照片
        mallImgFile: "",
        mallImgId: "",
        cashierImg: "", // 收银台照片
        cashierImgFile: "",
        cashierImgId: "",
        mallInnerImg1: "", // 门店内景照1
        mallInnerImg1File: "",
        mallInnerImg1Id: "",
        mallInnerImg2: "", // 门店内景照2
        mallInnerImg2File: "",
        mallInnerImg2Id: "",
        mallInnerImg3: "", // 门店内景照3
        mallInnerImg3File: "",
        mallInnerImg3Id: "",
        businessLicencesImg: "", // 营业执照
        businessLicencesImgFile: "",
        businessLicencesImgId: "",
      });
      if (!this.bykApi.smCom.fSmIsEmpty(this.openLoading)) {
        this.openLoading.close();
      }

      // 自助注册二维码 弹框
      this.isRegisterQRcodeDialogShow = false;
      this.isShowRegisterQRcode = false;
      this.registerQRcodeRate = "3.8";

      // 选择省市区弹框
    },

    // 选择地址弹框取消
    fChooseAddrCencal() {
      if (this.chooseAddrType == "bus") {
        this.shInfo.busSheng = "";
        this.shInfo.busShi = "";
        this.shInfo.busQu = "";
        this.shInfo.businessAddress = "";
      } else {
        this.shInfo.openSheng = "";
        this.shInfo.openShi = "";
        this.shInfo.openQu = "";
        this.shInfo.openingAddress = "";
      }
      this.isChooseAddr = false;
    },

    // 选择地址弹框确定
    fChooseAddrConfirm() {
      if (this.chooseAddrType == "bus") {
        this.shInfo.businessAddress =
          this.shInfo.busSheng +
          " " +
          this.shInfo.busShi +
          " " +
          this.shInfo.busQu;
      } else {
        this.shInfo.openingAddress =
          this.shInfo.openSheng +
          " " +
          this.shInfo.openShi +
          " " +
          this.shInfo.openQu;
      }
      this.isChooseAddr = false;
    },

    // 一键进件
    async fAtOnceSubmit() {
      this.isShPaymentConfigType = true;
    },

    // 小微 / 普通进件
    async fXwAndPtPayment(oper, type) {
      await this.fSave();
      let promiseList = this.promiseSplicimg();
      let isEmpty = this.paramsIsEmpty(type);
      if (!isEmpty) {
        return;
      }

      let p = Promise.all(promiseList);
      p.then(async (val) => {
        if (type == "xw") {
          // 小微
          // 提交进件前的 参数赋值
          // 银行卡 id 拼接
          this.xwPostJson.merchantDetail.indentityPhoto =
            this.shInfo.IDCardPositiveImgId +
            ";" +
            this.shInfo.IDCardOtherSideImgId;
          // 费率替换
          this.xwPostJson.mchPayConfs = this.xwPostJson.mchPayConfs.map(
            (item) => {
              if (
                item.payTypeId == "10000973" ||
                item.payTypeId == "10000974"
              ) {
                item.billRate1 = this.shInfo.rate;
              } else {
                item.billRate = this.shInfo.rate;
              }
              return item;
            }
          );
          // 门头照 id
          this.xwPostJson.merchantDetail.mainPhoto = this.shInfo.mallImgId;
          // 外商户号 为 手机号
          this.xwPostJson.outMerchantId = this.shInfo.phone;
          // 所属行业
          // 备注
          this.xwPostJson.remark = this.shInfo.remarks;
          // 商户名称
          this.xwPostJson.merchantName = this.shInfo.mallName;
          // 收款人名
          this.xwPostJson.merchantDetail.merchantShortName = this.shInfo.shName;
          this.xwPostJson.merchantDetail.principal = this.shInfo.payee;

          // 手机号
          this.xwPostJson.merchantDetail.customerPhone = this.shInfo.phone;
          this.xwPostJson.merchantDetail.principalMobile = this.shInfo.phone;
          // 邮箱
          this.xwPostJson.merchantDetail.email = this.shInfo.email;
          // 身份证号
          this.xwPostJson.merchantDetail.idCode = this.shInfo.IDCard;
          // 经营地址
          this.xwPostJson.merchantDetail.industrId = this.shInfo.industryId;

          this.xwPostJson.merchantDetail.address = this.shInfo.businessAddress;
          this.xwPostJson.merchantDetail.province = this.shInfo.busShengId;
          this.xwPostJson.merchantDetail.city = this.shInfo.busShiId;
          this.xwPostJson.merchantDetail.county = this.shInfo.busQuId;
          // 银行卡号
          this.xwPostJson.bankAccount.accountCode = this.shInfo.bankCard;
          // 银行卡绑定手机号
          this.xwPostJson.bankAccount.tel = this.shInfo.bankCardBindPhone;
          // 身份证号
          this.xwPostJson.bankAccount.idCard = this.shInfo.IDCard;
          // 银联号
          this.xwPostJson.bankAccount.contactLine = this.shInfo.UnionPayCode;
          // 开户银行
          this.xwPostJson.bankAccount.bankId = this.shInfo.bankOfDepositId;

          // 开户人
          this.xwPostJson.bankAccount.accountName = this.shInfo.payee;
          // 开户支行
          this.xwPostJson.bankAccount.bankName = this.shInfo.subBankOfDeposit;
          // 开户地址
          this.xwPostJson.bankAccount.province = this.shInfo.openShengId;
          this.xwPostJson.bankAccount.city = this.shInfo.openShiId;
          // 参数赋值结束
          //
          // return;


          if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.shCode)) {
            oper = "normal_mch_edit";
            this.xwPostJson.merchantId = this.shInfo.shCode;
            this.xwPostJson.merchantDetail.subjectType = "1";
          }
          this.data += this.spliceParam(this.xwPostJson) + "</merchant>";
        } else if (type == "pt") {
          // 提交进件前的 参数赋值
          // 银行卡 id 拼接
          this.ptPostJson.merchantDetail.indentityPhoto =
            this.shInfo.IDCardPositiveImgId +
            ";" +
            this.shInfo.IDCardOtherSideImgId;
          // 费率替换
          this.ptPostJson.mchPayConfs = this.ptPostJson.mchPayConfs.map(
            (item) => {
              if (
                item.payTypeId == "10000973" ||
                item.payTypeId == "10000974"
              ) {
                item.billRate1 = this.shInfo.rate;
              } else {
                item.billRate = this.shInfo.rate;
              }
              return item;
            }
          );
          // 门头照 id
          this.ptPostJson.merchantDetail.mainPhoto = this.shInfo.mallImgId;
          // 外商户号 为 手机号
          this.ptPostJson.outMerchantId = this.shInfo.phone;
          // 所属行业
          // 备注
          this.ptPostJson.remark = this.shInfo.remarks;
          // 商户名称
          this.ptPostJson.merchantName = this.shInfo.mallName;
          // 收款人名
          this.ptPostJson.merchantDetail.merchantShortName = this.shInfo.shName;
          this.ptPostJson.merchantDetail.principal = this.shInfo.payee;
          // 开户人
          this.ptPostJson.bankAccount.accountName = this.shInfo.payee;
          // 手机号
          this.ptPostJson.merchantDetail.customerPhone = this.shInfo.phone;
          this.ptPostJson.merchantDetail.principalMobile = this.shInfo.phone;
          // 邮箱
          this.ptPostJson.merchantDetail.email = this.shInfo.email;
          // 身份证号
          this.ptPostJson.merchantDetail.idCode = this.shInfo.IDCard;
          // 经营地址
          this.ptPostJson.merchantDetail.industrId = this.shInfo.industryId;
          this.ptPostJson.merchantDetail.address = this.shInfo.businessAddress;
          this.ptPostJson.merchantDetail.province = this.shInfo.busShengId;
          this.ptPostJson.merchantDetail.city = this.shInfo.busShiId;
          this.ptPostJson.merchantDetail.county = this.shInfo.busQuId;
          // 银行卡号
          this.ptPostJson.bankAccount.accountCode = this.shInfo.bankCard;
          // 银行卡绑定手机号
          this.ptPostJson.bankAccount.tel = this.shInfo.bankCardBindPhone;
          // 持卡人证件号码
          this.ptPostJson.bankAccount.idCard = this.shInfo.IDCard;
          // 银联号
          this.ptPostJson.bankAccount.contactLine = this.shInfo.UnionPayCode;
          // 开户银行
          this.ptPostJson.bankAccount.bankId = this.shInfo.bankOfDepositId;
          // 开户支行
          this.ptPostJson.bankAccount.bankName = this.shInfo.subBankOfDeposit;
          // 开户地址
          this.ptPostJson.bankAccount.province = this.shInfo.openShengId;
          this.ptPostJson.bankAccount.city = this.shInfo.openShiId;
          // 营业执照
          this.ptPostJson.merchantDetail.licensePhoto =
            this.shInfo.businessLicencesImgId;
          // 参数赋值结束
          if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.shCode)) {
            oper = "normal_mch_edit";
            this.ptPostJson.merchantId = this.shInfo.shCode;
            this.ptPostJson.merchantDetail.subjectType = "2";
          }
          this.data += this.spliceParam(this.ptPostJson) + "</merchant>";
          //
        }

        let resT = await this.fBykZgylUpShInfo("POST_DATA", oper, this.data);

        if (resT.result != "sucess") {
          this.data = "<merchant>";
          this.isShPaymentConfigType = false;
          if (resT.error_msg.split("，")[0] == "此证件号码已进件过商户") {
            // 如果已经证件进件过  再次将 商户号 存起来
            let resT1 = await this.fBykPayShInfoManger(
              "EDIT_SH_NO",
              this.shInfo.phone,
              resT.error_msg.split("：")[1],
              this.shInfo.partner_phone
            );
            //
            if (resT1.data.result != "sucess") {
              this.openLoading.close();
              // return this.$message(resT.msg);
            }
          }
          this.openLoading.close();

          return this.$message(resT.error_msg);
        }
        this.data = "<merchant>";
        // 这里调用补录接口  先将 商户号 存起来
        resT = await this.fBykPayShInfoManger(
          "EDIT_SH_NO",
          this.shInfo.phone,
          resT.merchantId,
          this.shInfo.partner_phone
        );
        if (resT.result != "sucess") {
          this.openLoading.close();
          // return this.$message(resT.msg);
        }

        await this.imgSupplement(resT.data, oper);
        this.init();
        this.$message("进件成功");
        this.data = "<merchant>";
        this.isShPaymentConfigType = false;
        this.fPaymentCancel();
      });
    },

    // 图片补录接口
    imgSupplement(shCode = "", oper = "") {
      return new Promise(async (resolve, reject) => {
        //
        this.imgSupplementList.merchantId = shCode || this.shInfo.shCode;
        if (oper != "normal_mch_edit") {
          // 银行卡照
          if (
            !this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardPositiveImgId)
          ) {
            this.imgSupplementList.merchantDetail.accountCodePhoto =
              this.shInfo.bankCardPositiveImgId;
          }
          if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg1Id)) {
            this.imgSupplementList.merchantDetail.businessPlace =
              this.shInfo.mallInnerImg1Id;
            if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg2Id)) {
              this.imgSupplementList.merchantDetail.businessPlace =
                this.imgSupplementList.merchantDetail.businessPlace +
                ";" +
                this.shInfo.mallInnerImg2Id;
              if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg3Id)) {
                this.imgSupplementList.merchantDetail.businessPlace =
                  this.imgSupplementList.merchantDetail.businessPlace +
                  ";" +
                  this.shInfo.mallInnerImg3Id;
              }
            }
          }
        }
        // this.imgSupplementList.merchantDetail.mainPhoto = this.shInfo.mallImgId;
        // this.imgSupplementList.merchantDetail.accountCodePhoto =
        //   this.shInfo.bankCardPositiveImgId;
        // XML 格式 的转换
        this.data += this.spliceParam(this.imgSupplementList) + "</merchant>";
        if (
          this.data ==
            "<merchant><merchantDetail></merchantDetail></merchant>" ||
          this.data ==
            "<merchant><merchantId>" +
              this.imgSupplementList.merchantId +
              "</merchantId><merchantDetail></merchantDetail></merchant>"
        ) {
          this.openLoading.close();
          resolve();
          return;
        }
        // 调用接口 提交 mch_pic_edit
        let resT = await this.fBykZgylUpShInfo(
          "POST_DATA",
          "mch_pic_edit",
          this.data
        );

        if (resT.result != "sucess") {
          this.$message(resT.error_msg);
          this.data = "<merchant>";
          this.openLoading.close();
          return;
        }
        resolve();
      });
    },

    // 支付进件的 promise 列表
    promiseSplicimg() {
      let promiseList = [];
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardPositiveImg)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.IDCardPositiveImg,
          "sfzzm"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardOtherSideImg)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.IDCardOtherSideImg,
          "sfzfm"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardPositiveImg)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.bankCardPositiveImg,
          "yhkzm"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardOtherSideImg)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.bankCardOtherSideImg,
          "yhkfm"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallImg)) {
        let promise = this.atOnceSubmitgetImgId(this.shInfo.mallImg, "mtz");
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.cashierImg)) {
        let promise = this.atOnceSubmitgetImgId(this.shInfo.cashierImg, "syt");
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg1)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.mallInnerImg1,
          "njz1"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg2)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.mallInnerImg2,
          "njz2"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg3)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.mallInnerImg3,
          "njz3"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessLicencesImg)) {
        let promise = this.atOnceSubmitgetImgId(
          this.shInfo.businessLicencesImg,
          "yyzz"
        );
        if (!this.bykApi.smCom.fSmIsEmpty(promise)) {
          promiseList.push(promise);
        }
      }
      return promiseList;
    },

    // 一键进件的 图片上传  获取 图片 id
    async atOnceSubmitgetImgId(url, urlName) {
      return new Promise(async (reslove, reject) => {
        let resT = await this.fBykZgylUpShInfo(
          "UP_IMG",
          "pic_upload",
          "D:\\web\\userFiles\\4008768278\\pay\\" +
            url.split("/")[url.split("/").length - 1]
        );

        if (resT.result != "sucess") {
          this.$message(resT.msg);
          this.openLoading.close();
          reject();
        }
        if (urlName == "sfzzm") {
          this.shInfo.IDCardPositiveImgId = resT.data;
        }
        if (urlName == "sfzfm") {
          this.shInfo.IDCardOtherSideImgId = resT.data;
        }
        if (urlName == "yhkzm") {
          this.shInfo.bankCardPositiveImgId = resT.data;
        }
        if (urlName == "yhkfm") {
          this.shInfo.bankCardOtherSideImgId = resT.data;
        }
        if (urlName == "mtz") {
          this.shInfo.mallImgId = resT.data;
        }
        if (urlName == "syt") {
          this.shInfo.cashierImgId = resT.data;
        }
        if (urlName == "njz1") {
          this.shInfo.mallInnerImg1Id = resT.data;
        }
        if (urlName == "njz2") {
          this.shInfo.mallInnerImg2Id = resT.data;
        }
        if (urlName == "njz3") {
          this.shInfo.mallInnerImg3Id = resT.data;
        }
        if (urlName == "yyzz") {
          this.shInfo.businessLicencesImgId = resT.data;
        }
        reslove();
      });
    },
    // 上传图片  获取本地路径
    fUploadImgGetLocalUrl() {
      return new Promise(async (resolve, reject) => {
        let formData = this.formDataSplicing();
        this.axios({
          method: "post",
          url: "http://www.91byk.com:1880/fileServerApi.asq",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }).then((res) => {
          //
          this.loaclUrlFromNetworkUrl();
          resolve();
        });
      });
    },
    // 图片类型的判断
    fImgType(raw) {
      if (raw.type == "image/png") {
        return ".png";
      } else if (raw.type == "image/jpeg") {
        return ".jpg";
      }
    },

    // 上传图片 获取本地路径的参数拼接
    formDataSplicing() {
      let isEmpty = this.paramsIsEmpty();
      if (!isEmpty) {
        return;
      }
      let formData = new FormData();
      formData.append(
        "serverFilePath",
        "D:\\web\\userFiles\\4008768278\\pay\\"
      );
      // 身份证 正面
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardPositiveImgFile)) {
        formData.append(
          "file1name",
          this.shInfo.phone +
            "sfzzm" +
            this.fImgType(this.shInfo.IDCardPositiveImgFile)
        );
        formData.append("file1", this.shInfo.IDCardPositiveImgFile);
      }
      // 身份证 反面
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardOtherSideImgFile)) {
        formData.append(
          "file2name",
          this.shInfo.phone +
            "sfzfm" +
            this.fImgType(this.shInfo.IDCardOtherSideImgFile)
        );
        formData.append("file2", this.shInfo.IDCardOtherSideImgFile);
      }
      // 银行卡 正面
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardPositiveImgFile)) {
        formData.append(
          "file3name",
          this.shInfo.phone +
            "yhkzm" +
            this.fImgType(this.shInfo.bankCardPositiveImgFile)
        );
        formData.append("file3", this.shInfo.bankCardPositiveImgFile);
      }
      // 银行卡 反面
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardOtherSideImgFile)) {
        formData.append(
          "file4name",
          this.shInfo.phone +
            "yhkfm" +
            this.fImgType(this.shInfo.bankCardOtherSideImgFile)
        );
        formData.append("file4", this.shInfo.bankCardOtherSideImgFile);
      }
      // 门头照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallImgFile)) {
        formData.append(
          "file5name",
          this.shInfo.phone + "mtz" + this.fImgType(this.shInfo.mallImgFile)
        );
        formData.append("file5", this.shInfo.mallImgFile);
      }
      // 收银台照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.cashierImgFile)) {
        formData.append(
          "file6name",
          this.shInfo.phone + "syt" + this.fImgType(this.shInfo.cashierImgFile)
        );
        formData.append("file6", this.shInfo.cashierImgFile);
      }
      // 门店内景照1
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg1File)) {
        formData.append(
          "file7name",
          this.shInfo.phone +
            "njz1" +
            this.fImgType(this.shInfo.mallInnerImg1File)
        );
        formData.append("file7", this.shInfo.mallInnerImg1File);
      }
      // 门店内景照2
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg2File)) {
        formData.append(
          "file8name",
          this.shInfo.phone +
            "njz2" +
            this.fImgType(this.shInfo.mallInnerImg2File)
        );
        formData.append("file8", this.shInfo.mallInnerImg2File);
      }
      // 门店内景照3
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg3File)) {
        formData.append(
          "file9name",
          this.shInfo.phone +
            "njz3" +
            this.fImgType(this.shInfo.mallInnerImg3File)
        );
        formData.append("file9", this.shInfo.mallInnerImg3File);
      }
      // 营业执照
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessLicencesImgFile)) {
        formData.append(
          "file10name",
          this.shInfo.phone +
            "yyzz" +
            this.fImgType(this.shInfo.businessLicencesImgFile)
        );
        formData.append("file10", this.shInfo.businessLicencesImgFile);
      }

      return formData;
    },

    // 将上传的图片的本地路径转换成网络路径
    loaclUrlFromNetworkUrl() {
      let loaclPath = "http://www.91byk.com/userFiles/4008768278/pay/";
      // 正面身份证照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardPositiveImgFile)) {
        this.shInfo.IDCardPositiveImg =
          loaclPath +
          this.shInfo.phone +
          "sfzzm" +
          this.fImgType(this.shInfo.IDCardPositiveImgFile);
      }
      // 反面身份证照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardOtherSideImgFile)) {
        this.shInfo.IDCardOtherSideImg =
          loaclPath +
          this.shInfo.phone +
          "sfzfm" +
          this.fImgType(this.shInfo.IDCardOtherSideImgFile);
      }
      // 正面银行卡照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardPositiveImgFile)) {
        this.shInfo.bankCardPositiveImg =
          loaclPath +
          this.shInfo.phone +
          "yhkzm" +
          this.fImgType(this.shInfo.bankCardPositiveImgFile);
      }
      // 反面银行卡照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardOtherSideImgFile)) {
        this.shInfo.bankCardOtherSideImg =
          loaclPath +
          this.shInfo.phone +
          "yhkfm" +
          this.fImgType(this.shInfo.bankCardOtherSideImgFile);
      }
      // 门头照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallImgFile)) {
        this.shInfo.mallImg =
          loaclPath +
          this.shInfo.phone +
          "mtz" +
          this.fImgType(this.shInfo.mallImgFile);
      }
      // 收银台照片
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.cashierImgFile)) {
        this.shInfo.cashierImg =
          loaclPath +
          this.shInfo.phone +
          "syt" +
          this.fImgType(this.shInfo.cashierImgFile);
      }
      // 门店内景照1
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg1File)) {
        this.shInfo.mallInnerImg1 =
          loaclPath +
          this.shInfo.phone +
          "njz1" +
          this.fImgType(this.shInfo.mallInnerImg1File);
      }
      // 门店内景照2
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg2File)) {
        this.shInfo.mallInnerImg2 =
          loaclPath +
          this.shInfo.phone +
          "njz2" +
          this.fImgType(this.shInfo.mallInnerImg2File);
      }
      // 门店内景照3
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallInnerImg3File)) {
        this.shInfo.mallInnerImg3 =
          loaclPath +
          this.shInfo.phone +
          "njz3" +
          this.fImgType(this.shInfo.mallInnerImg3File);
      }
      // 营业执照
      if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessLicencesImgFile)) {
        this.shInfo.businessLicencesImg =
          loaclPath +
          this.shInfo.phone +
          "yyzz" +
          this.fImgType(this.shInfo.businessLicencesImgFile);
      }
    },

    // ------------------ 小微进件 ↑↑↑↑↑↑↑↑ -----------------------

    // 清除指定的图片
    fCancelImg(type) {
      this.shInfo[type] = "";
      this.shInfo[type + "File"] = "";
    },

    // 删除用户信息
    fDel() {
      //
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await this.fBykPayShInfoManger(
          "DEL",
          "",
          "",
          this.shInfo.partner_phone
        );
        //
        if (res.result != "sucess") {
          this.$message(res.msg);
          this.openLoading.close();
          return;
        }
        this.$message(res.msg);
        this.isShPaymentConfig = false;
        this.fPaymentCancel();
        this.init();
      });
    },

    // 保存信息
    async fSave(param = "") {
      return new Promise(async (resolve, reject) => {
        let isEmpty = this.paramsIsEmpty();
        if (!isEmpty) {
          return;
        }
        this.openLoading = this.$loading({
          // 声明一个loading对象
          lock: true, // 是否锁屏
          text: "正在上传图片...", // 加载动画的文字
          spinner: "el-icon-loading", // 引入的loading图标
          background: "rgba(0, 0, 0, 0.3)", // 背景颜色
          // target: ".payment", // 需要遮罩的区域
          body: true,
          color: "#000",
          customClass: "mask", // 遮罩层新增类名
        });
        await this.fUploadImgGetLocalUrl();
        if (this.addOrEditPaymentConfig == "ADD") {


        }
        let res = await this.fBykPayShInfoManger(
          this.addOrEditPaymentConfig,
          "",
          "",
          this.shInfo.partner_phone
        );

        if (res.result != "sucess") {
          this.$message(res.msg);
          this.openLoading.close();
          return;
        }
        if (!this.bykApi.smCom.fSmIsEmpty(this.shInfo.shCode)) {
          res = await this.fBykPayShInfoManger(
            "EDIT_SH_NO",
            this.shInfo.phone,
            this.shInfo.shCode,
            this.shInfo.partner_phone
          );

          if (res.result != "sucess") {
            this.$message(res.msg);
            this.openLoading.close();
            return;
          }
        }
        if (param == "save") {
          this.$message(res.msg);
          this.fPaymentCancel();
        }
        //
        this.init();
        resolve();
      }).then(() => {
        if (param == "save") {
          this.fPaymentCancel();
        }
      });
    },

    // 填写内容的校验
    paramsIsEmpty(type = "") {
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallName)) {
        this.$message("请输入商户名称");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shName)) {
        this.$message("请输入商户简称");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.industry)) {
        this.$message("请选择所属行业");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.payee)) {
        this.$message("请输入收款人名");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.phone)) {
        this.$message("请输入手机号码");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCard)) {
        this.$message("请输入身份证号");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessAddress)) {
        this.$message("请选择经营地址");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessLicencesCode)) {
        this.$message("请输入营业执照编码");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.rate)) {
        this.$message("请输入费率");
        return false;
      }
      if (this.shInfo.tare > 6 || this.shInfo.rate < 2) {
        this.$message("费率在 2 ~ 6 之间");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCard)) {
        this.$message("请输入银行卡号");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankCardBindPhone)) {
        this.$message("请输入银行卡绑定的手机号");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.UnionPayCode)) {
        this.$message("请输入银联号");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.bankOfDeposit)) {
        this.$message("请输入开户银行");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.subBankOfDeposit)) {
        this.$message("请输入开户支行");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.openingAddress)) {
        this.$message("请输入开户地址");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.detailAddr)) {
        this.$message("请输入详细地址");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardPositiveImg)) {
        this.$message("请上传身份证正面照片");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.IDCardOtherSideImg)) {
        this.$message("请上传身份证反面照片");
        return false;
      }
      if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.email)) {
        this.$message("请输入邮箱");
        return false;
      }
      if (type == "xw") {
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.mallImg)) {
          this.$message("请上传门头照照片");
          return false;
        }
      }
      if (type == "pt") {

        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.businessLicencesImg)) {
          this.$message("请上传营业执照");
          return false;
        }
      }
      return true;
    },

    // ---------------------- 请求 开始 ------------------------

    // 百度图片识别
    async fGetBaiDuOcrResult(imgBase64) {

      let postJson = {};
      postJson["METHOD_NAME"] = "GET_BAIDU_OCR_RESULT";
      postJson["OPER"] = this.imgType;
      if (this.imgType == "SFZ") {
        postJson["PARAMS"] = "id_card_side=front&image=" + imgBase64;
      } else if (this.imgType == "YHK") {
        postJson["PARAMS"] = "detect_direction=false&image=" + imgBase64;
      } else if (this.imgType == "YYZZ") {
        postJson["PARAMS"] = "image=" + imgBase64;
      } else {
        return;
      }
      let res = await this.bykApi.postApi.fPostToBaiDuApi(postJson);

      if (res.data.result != "sucess") {
        return this.$message(res.data.msg);
      }
      if (this.imgType == "SFZ") {
        this.shInfo.IDCard = res.data.data.words_result["公民身份号码"].words;
        this.shInfo.payee = res.data.data.words_result["姓名"].words;
      } else if (this.imgType == "YHK") {
        this.shInfo.bankCard = res.data.data.result.bank_card_number.replace(
          / /g,
          ""
        );
      } else if (this.imgType == "YYZZ") {
        this.shInfo.businessLicencesCode =
          res.data.data.words_result["社会信用代码"].words;
        this.shInfo.mallName = res.data.data.words_result["单位名称"].words;
        // this.shInfo.detailAddr = res.data.data.words_result['地址'].words
      } else {
        return;
      }
      return res;
    },

    // 中国银联进件
    async fBykZgylUpShInfo(oper, serviceName, data = "") {
      let postJson = {};
      postJson["METHOD_NAME"] = "ZGYL_UP_SH_INFO";
      postJson["OPER"] = oper;
      postJson["PHONE_NO"] = "18957102098";
      postJson["PARTNER_PHONE"] = this.shInfo.partner_phone;
      postJson["SERVICE_NAME"] = serviceName;
      if (
        serviceName == "small_mch_add" ||
        serviceName == "normal_mch_edit" ||
        serviceName == "normal_mch_add" ||
        serviceName == "mch_pic_edit"
      ) {
        postJson["DATA"] = data;
      } else if (serviceName == "pic_upload") {
        postJson["PIC_PATH"] = data;
      }
      postJson["USER_SERVER_IP"] = "8.142.45.98";

      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);

      return res.data;
    },

    // 添加 / 修改进件
    async fBykPayShInfoManger(
      oper,
      shPhone = "",
      shCode = "",
      partnerPhone = ""
    ) {
      let userName = JSON.parse(localStorage.getItem("bykPlatform")).partnerInfo
        .data.user_name;
      let postJson = {};
      postJson["METHOD_NAME"] = "PAY_SH_INFO_MANGER";
      postJson["OPER"] = oper;
      postJson["PARTNER_PHONE"] = partnerPhone;
      postJson["SH_PHONE"] = this.shInfo.phone;
      if (oper == "GET" || oper == "GET_SH_PHONE" || oper == "EDIT_SH_NO") {
        postJson["SH_PHONE"] = shPhone;
      }
      postJson["SH_NO"] = shCode || this.shInfo.shCode;
      postJson["BUS_TYPE"] = this.shInfo.industry;
      postJson["BUS_TYPE_NO"] = this.shInfo.industryId;
      postJson["USER_MEMO"] = this.shInfo.remarks;

      postJson["SH_EMAIL"] = this.shInfo.email;

      postJson["PHONE_NO"] = "18957102098";
      postJson["SH_NAME"] = this.shInfo.payee;
      postJson["SFZ_NO"] = this.shInfo.IDCard;
      postJson["MD_NAME"] = this.shInfo.mallName;
      postJson["SH_SIM_NAME"] = this.shInfo.shName;
      postJson["MD_SHEN"] = this.shInfo.busSheng;
      postJson["MD_SHEN_ID"] = this.shInfo.busShengId;

      postJson["MD_SHI"] = this.shInfo.busShi;
      postJson["MD_SHI_ID"] = this.shInfo.busShiId;

      postJson["MD_QU"] = this.shInfo.busQu;
      postJson["MD_QU_ID"] = this.shInfo.busQuId;

      postJson["MD_ADR"] = this.shInfo.detailAddr;
      postJson["SK_FL_VALUE"] = this.shInfo.rate;
      postJson["YHK_NO"] = this.shInfo.bankCard;
      postJson["YHK_PHONE"] = this.shInfo.bankCardBindPhone;
      postJson["YHK_SHEN"] = this.shInfo.openSheng;
      postJson["YHK_SHEN_ID"] = this.shInfo.openShengId;
      postJson["YHK_SHI"] = this.shInfo.openShi;
      postJson["YHK_SHI_ID"] = this.shInfo.openShiId;

      postJson["YHK_QU"] = this.shInfo.openQu;
      postJson["YHK_QU_ID"] = this.shInfo.openQuId;

      postJson["YHK_KHH_NAME"] = this.shInfo.bankOfDeposit;
      postJson["YHK_KHH_ID"] = this.shInfo.bankOfDepositId;

      postJson["YHK_KHH_ZH_NAME"] = this.shInfo.subBankOfDeposit;
      postJson["YHK_KHH_ZH_NO"] = this.shInfo.UnionPayCode;
      postJson["PIC_SFZ_ZM_URL"] = this.shInfo.IDCardPositiveImg;
      postJson["PIC_SFZ_FM_URL"] = this.shInfo.IDCardOtherSideImg;
      postJson["PIC_YHK_ZM_URL"] = this.shInfo.bankCardPositiveImg;
      postJson["PIC_YHK_FM_URL"] = this.shInfo.bankCardOtherSideImg;
      postJson["PIC_MTZ_URL"] = this.shInfo.mallImg;
      postJson["PIC_NJZ1_URL"] = this.shInfo.mallInnerImg1;
      postJson["PIC_NJZ2_URL"] = this.shInfo.mallInnerImg2;
      postJson["PIC_NJZ3_URL"] = this.shInfo.mallInnerImg3;
      postJson["CHG_USER_NAME"] = userName;
      postJson["PIC_SYT_URL"] = this.shInfo.cashierImg;
      postJson["YYZZ_NO"] = this.shInfo.businessLicencesCode;
      postJson["PIC_YYZZ_URL"] = this.shInfo.businessLicencesImg;
      postJson["SEARCH_STR"] = this.payInputVal;
      postJson["PAGE_SIZE"] = 10;
      postJson["NOW_PAGE"] = this.nowPage;
      postJson["MH_YN"] = "Y";


      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);

      return res.data;
    },

    // 提交 商户号
    async fBykSubmitShNo(shNo) {
      let postJson = {};
      postJson["METHOD_NAME"] = "PAY_SH_INFO_MANGER";
      postJson["PHONE_NO"] = "18957102098";
      postJson["OPER"] = "EDIT_SH_NO";
      postJson["SH_NO"] = shNo;

      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);
      //
      return res.data;
    },

    // 提交 贝友客手机号
    async fBykSubmitBykPhone(bykPhone) {
      let postJson = {};
      postJson["METHOD_NAME"] = "PAY_SH_INFO_MANGER";
      postJson["OPER"] = "EDIT_BYK_PHONE";
      postJson["BYK_PHONE"] = bykPhone;

      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);
      //
      return res.data;
    },

    // 获取银联银行信息
    async fBykGetZgylBankInfo(val, oper) {
      let postJson = {};
      postJson["METHOD_NAME"] = "GET_ZGYL_BANK_INFO";
      postJson["PHONE_NO"] = "18957102098";
      postJson["OPER"] = oper;
      postJson["SEARCH_STR"] = val;
      postJson["SHEN_NAME"] = this.shInfo.openSheng;
      postJson["SHI_NAME"] = this.shInfo.openShi;
      postJson["BANK_NAME"] = this.shInfo.bankOfDeposit;
      postJson["SUB_BANK_NAME"] = this.shInfo.subBankOfDeposit;

      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);
      //
      return res.data;
    },

    // 获取省市区 列表信息
    async fBykGetZgylAreaInfo(code = "") {
      let postJson = {};
      postJson["METHOD_NAME"] = "GET_ZGYL_AREA_INFO";
      postJson["PHONE_NO"] = "18957102098";
      postJson["P_CODE"] = code;
      //
      let res = await this.bykApi.postApi.fPostToPayInfoApi(postJson);

      return res.data;
    },

    // ---------------------- 请求 结束 ------------------------
    // 开户行支行选择
    fBankChange(e, type) {

      if (this.bykApi.smCom.fSmIsEmpty(e)) {
        return;
      }
      let val = "";
      if (type == "bank") {

        val = this.bankOptions.find((item) => {
          return item.value == e;
        });
      } else if (type == "sub-bank") {
        val = this.oldSubBankOptions.find((item) => {
          return item.bank_no == e;
        });
      }

      if (val != -1) {
        if (type == "bank") {
          this.shInfo.bankOfDeposit = val.label;
          this.shInfo.bankOfDepositId = val.value;
        } else if (type == "sub-bank") {
          this.shInfo.bankOfDeposit = val.bank_name;
          this.shInfo.bankOfDepositId = val.bank_id;
          // this.shInfo.openSheng = val.shen_name;
          // this.shInfo.openShengId = val.shen_id;
          // this.shInfo.openShi = val.city_name;
          // this.shInfo.openShiId = val.city_id;
          // this.shInfo.openingAddress = val.shen_name + " " + val.city_name;
          // this.shInfo.subBankOfDeposit = val.sub_bank_name;
          this.shInfo.UnionPayCode = val.bank_no;
        }
      }
    },
    // 开户银行 接口 搜索
    async fBankRemoteMethod(query) {

      // setTimeout(async () => {
      let res = await this.fBykGetZgylBankInfo(query, "BANK_NAME");

      if (res.result != "sucess") {
        return this.$message(res.msg);
      }
      let tempOptions = res.data;
      this.bankOptions = tempOptions.map((item) => {
        let obj = {
          label: item.bank_name,
          value: item.bank_id,
        };
        return obj;
      });

      // }, 200);
    },
    // 支行 接口 搜索
    async fSubBankRemoteMethod(query) {

      // setTimeout(async () => {
      let res = await this.fBykGetZgylBankInfo(query, "SUB_BANK_NAME");

      if (res.result != "sucess") {
        return this.$message(res.msg);
      }
      this.oldSubBankOptions = res.data;
      let tempOptions = res.data;
      this.subBankOptions = tempOptions.map((item) => {
        let obj = {
          label: item.sub_bank_name,
          value: item.bank_no,
        };
        return obj;
      });

      // }, 200);
    },

    // 分页函数
    fCurrentChange(e) {
      this.nowPage = e;
      this.init();
    },
  },
};
</script>

<style lang="less" scoped>
.payment {
  .title-left-line {
    position: relative;
    display: flex;
    align-content: center;
    &::before {
      content: "";
      display: flex;
      width: 3px;
      border-radius: 1px;
      height: 15px;
      background-color: #409eff;
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .must {
    &::before {
      content: "*";
      color: #f40;
      margin-right: 2px;
    }
  }

  /deep/ .el-input-group__append {
    background-color: #409eff;
    color: #fff;
    border: 1px solid #409eff;
  }
  /deep/ .el-dialog__body {
    padding: 20px 30px 30px;
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .vxe-table--render-default .vxe-cell {
    white-space: normal !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/payment.vue